module.exports = __webpack_public_path__ + "img/gasCrisis.c531156.jpg";